// removed by extract-text-webpack-plugin
module.exports = {"root":"UploadFile__root___2Dmjo","label":"UploadFile__label___uDm1P","text":"UploadFile__text___uF5jN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/form/UploadFile/UploadFile.scss
// module id = 2225
// module chunks = 0